import React, { Component } from "react";
import ArcadeGamesCardComponent from "../../Categories/ArcadeGamesCardComponent";
import loadinggif from "../../../assets/images/loading.gif";
import navArrowRightBlue from "../../../assets/images/svg/nav-arrow-right-blue.svg";
import "./ArcadeGamesByCategoryViewAllComponent.scss";
import { withTranslation } from "react-i18next";
import i18n from "../../../i18n";

class ArcadeGamesByCategoryViewAllComponent extends Component {
  componentDidMount() {
    const {
      fetchArcadeGamesByCategoryViewAllIfNeeded,
      invalidateAllArcadeGamesByCategoryViewAll
    } = this.props;
    invalidateAllArcadeGamesByCategoryViewAll();
    fetchArcadeGamesByCategoryViewAllIfNeeded({
      categoryId: this.props.match.params.id,
      page: 1
    });
  }

  componentDidUpdate() {
    document.body.classList.remove("modal-open");
  }

  render() {
    let { page, t } = this.props;
    const lang = i18n.language;
    return (
      <section className="container-fluid free-game-wrapper">
        <div className="row">
          <div className="container">
            <div className="padder-main">
              <div className="row d-flex align-items-center mb-30 ">
                <div className="col-sm-12 text-right d-flex justify-content-start mb-2 back-arrow">
                  <a
                    href={"/" + lang + "/dashboard"}
                    className="view-all d-flex align-items-center"
                  >
                    {/* <span>
                      <img src={navArrowRightBlue} alt=""></img>
                    </span> */}
                    <h5 className="bold">
                      <img src={navArrowRightBlue} alt=""></img>
                      {t("back")}{" "}
                    </h5>
                  </a>
                </div>
                <div className="col-sm-12">
                  <h2 className="bold">
                    {this.props.match.params.description} -{" "}
                    {t("freeToPlayGame")}
                  </h2>
                </div>
              </div>

              <div className="row card-wrapper d-flex justify-content-center justify-content-sm-start free-game-collumn">
                {this.props.ArcadeGamesByCategoryViewAll.items.length > 0
                  ? this.props.ArcadeGamesByCategoryViewAll.items.map(
                      (tournament, i) => (
                        <div className="col-auto mb-5" key={i}>
                          <ArcadeGamesCardComponent
                            {...tournament}
                            cardClass="free-to-play-game"
                            brandAvatarClass=""
                          />
                        </div>
                      )
                    )
                  : ""}
              </div>

              <div className="row mb-30 text-center">
                <div className="col-sm-12">
                  {this.props.ArcadeGamesByCategoryViewAll.items.length > 0 ? (
                    !this.props.ArcadeGamesByCategoryViewAll.isLastPage ? (
                      <button
                        onClick={() => {
                          this.props.invalidateArcadeGamesByCategoryViewAll();
                          this.props.fetchArcadeGamesByCategoryViewAllIfNeeded({
                            categoryId: this.props.match.params.id,
                            page: page
                          });
                        }}
                        className="btn btn-pink dark btn-xs"
                      >
                        {t("loadMore")}
                      </button>
                    ) : this.props.ArcadeGamesByCategoryViewAll.isFetching ? (
                      <img src={loadinggif} alt="" />
                    ) : (
                      ""
                    )
                  ) : this.props.ArcadeGamesByCategoryViewAll.isFetching ? (
                    <img className="text-center" src={loadinggif} alt="" />
                  ) : (
                    <span>{t("noGameFound")}</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default withTranslation()(ArcadeGamesByCategoryViewAllComponent);
